import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import {
  LEAD_SOURCES,
  LEAD_SOURCES_ALTERNATIVE_NAME_MAP,
} from '../../../libs/lead-source/constants';
import Validate from '../../../libs/validate';

export function wrapFieldCallback(func) {
  return (event, { value, checked, type } = {}) => {
    const finalValue = type === 'checkbox' ? checked : value || event.target.value;
    return func(finalValue);
  };
}

function getLeadSourceText(leadSource) {
  return _get(LEAD_SOURCES_ALTERNATIVE_NAME_MAP, leadSource, leadSource);
}

export function getLeadSourceOptions() {
  return LEAD_SOURCES.map((source) => ({
    key: source,
    text: getLeadSourceText(source),
    value: source,
  }));
}

export function getFormValidationMessage(formData = {}, useManualAddress = false) {
  const { businessName, businessSubtype, businessOwnerPhone, placeId, businessOwnerEmail } =
    formData;
  if (_isEmpty(businessName)) {
    return 'The Business Name field is required';
  }
  if (_isEmpty(businessSubtype)) {
    return 'The Business Type field is required';
  }
  if (!_isEmpty(businessOwnerPhone) && !Validate.validate('phone', businessOwnerPhone)) {
    return 'The Business Owner Mobile Phone is invalid';
  }

  if (_isEmpty(businessOwnerPhone) && _isEmpty(businessOwnerEmail)) {
    return 'Please provide either a phone or email';
  }

  if (!useManualAddress && _isEmpty(placeId)) {
    return 'Make sure to select a valid Business Name';
  }
  return '';
}

/**
 * Transforms form data to the unified registration payload format
 * @param {Object} formData - The form data from SignUpForm (camelCase)
 * @param {string} formData.businessName - Business name (required)
 * @param {string} formData.businessSubtype - Business subtype (optional)
 * @param {Object} formData.businessOwner - Business owner object (camelCase)
 * @param {Object} formData.businessAddress - Business address object (camelCase)
 * @param {Object} formData.metadata - Metadata object (camelCase)
 * @returns {Object} Transformed payload matching RegistrationSerializer format (snake_case)
 */
export function transformToRegistrationPayload(formData) {
  const {
    businessName,
    businessSubtype = '',
    businessOwner = {},
    businessAddress = {},
    metadata = {},
  } = formData;

  const payload = {
    business_name: businessName,
    business_owner: {
      owner_name: businessOwner.ownerName || '',
      owner_email: businessOwner.ownerEmail || '',
      owner_phone: businessOwner.ownerPhone || '',
    },
    business_address: {
      street: businessAddress.street || '',
      city: businessAddress.city || '',
      state: businessAddress.state || '',
      postal_code: businessAddress.postalCode || '',
    },
    business_subtype: businessSubtype || '',
    metadata: {
      lead_source: metadata.leadSource || '',
      lead_id: metadata.leadId || '',
      place_id: _isEmpty(metadata.placeId) ? null : metadata.placeId,
      palette_id: _isEmpty(metadata.paletteId) ? null : metadata.paletteId,
      recipe_name: _isEmpty(metadata.recipeName) ? null : metadata.recipeName,
      lead_channel: _isEmpty(metadata.leadChannel) ? null : metadata.leadChannel,
      referral_email: _isEmpty(metadata.referralEmail) ? null : metadata.referralEmail,
      previous_website_url: _isEmpty(metadata.previousWebsiteUrl)
        ? null
        : metadata.previousWebsiteUrl,
    },
    source: 'rep_dashboard',
  };

  return payload;
}
